import React, { useContext, useEffect, useState } from "react";
import Courses from "../../Templates/Courses/Courses";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { courseURL, schoolListURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";

function CoursesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [totalCount, setTotalCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [courses, setCourses] = useState([]);
  const { data, loading, error } = useFetch(
    courseURL,
    page,
    rowsPerPage,
    search,
    null,
    null,
    `${sort}${filter}`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setCourses(data?.data?.data?.rows);
      setPageCount(data?.data?.data?.numberOfPages);
      setTotalCount(data?.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Courses
      page={page}
      rowsPerPage={rowsPerPage}
      totalCount={totalCount}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      courses={courses}
      navigate={navigate}
      handleChangePage={handleChangePage}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setCourses={setCourses}
      setFilter={setFilter}
      setSort={setSort}
      currentSort={sort}
    />
  );
}

export default CoursesPage;
